import styles from './Profile.module.scss';
import { API_URL } from '../../../../constants';
import { useGetUser } from '../../../../hooks/useGetUser';
import defaultAvatar from '../../../../assets/avatar.png';
import React, { useEffect, useState } from 'react';
import { getUserAvatar } from '../../../../api/user';
import { Verified } from '../../../Shared/Verified/Verified';
import { useGetWithdrawRequest } from '../../../../hooks/useGetWithdrawRequest';

interface IProfileProps {
    userId: string;
    withdrawRequestId: string;
}

export const Profile = ({ userId, withdrawRequestId }: IProfileProps) => {
    if (!userId || !withdrawRequestId) return null;

    const { userData, isLoading: isLoadingUser } = useGetUser(userId);
    const { withdrawRequestData, isLoading: isLoadingWithdrawRequest } = useGetWithdrawRequest({
        id: withdrawRequestId,
    });

    const isLoading = isLoadingWithdrawRequest && isLoadingUser;

    if (isLoading || !userData || !withdrawRequestData) return <div className={styles.container}></div>;

    return (
        <div className={styles.container}>
            <img
                src={userData.avatar ? `${API_URL}/${userData.avatar}` : defaultAvatar}
                className={styles.avatar}
            ></img>
            <div className={styles.column}>
                <div className={styles.nick}>
                    {userData.phoneNumber}
                    <div className={styles.verified}>
                        <Verified isVerified={!!withdrawRequestData.isVerified} />
                    </div>
                </div>
                <div className={styles.phone}>ID: {userId}</div>
            </div>
        </div>
    );
};
